import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { useFormik } from "formik"
import VendorsTable from "./VendorsTable"
import { UnBillsType } from "_mock/Static_data"
import { exportDataExcel } from "components/Common/ExportData"
import TransactionTable from "./TransactionTable"
import { dateFormat } from "pages/Common"

function Vendors() {
  document.title = `Vendors | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [vendorId, setVendorId] = useState(0)
  const [transactionData, setTransactionData] = useState([])
  const [transactionModal, setTransactionModal] = useState(false)

  // vendor list api
  const vendorsApi = () => {
    setScreenLoad(true)
    setIsLoading(true)
    getApi("Common/vendor/list").then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
        setTotalRecords(data.length)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setScreenLoad(false)
    })
  }

  // vendor list api useEffect
  useEffect(() => {
    vendorsApi()
  }, [])

  // toggle handlers
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const toggleTransaction = () => {
    setTransactionModal(!transactionModal)
  }


  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Delete vendor handler
  const handleDelete = vendorId => {
    setScreenLoad(true)
    if (vendorId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this vendor permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`Common/vendor/delete?Id=${vendorId}`).then(
            ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== vendorId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("successfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                ErrorModel.errormodel({
                  title: "Verify Vendor",
                  text: data,
                })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // Update vendor handler
  const handleEditVendor = vendordata => {
    if (vendordata) {
      setVendorId(vendordata.Id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(vendordata)
    }
  }

  // Create vendor handler
  const handleVendorClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Vendors Validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Name: isEdit ? editData?.Name : "",
      ContactNo: isEdit ? editData?.ContactNo : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The name is required"),
      ContactNo: Yup.string().required("The contact no. is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        postApi("Common/vendor/addedit", {
          id: isEdit ? parseInt(vendorId) : 0,
          Name: values.Name,
          ContactNo: values.ContactNo,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 400) {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toast.success(isEdit ? "successfully updated" : "successfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            vendorsApi()
            validation.handleReset()
          }
        })
      }
    },
  })

  const handleViewTransaction = (VendorId) => {
    if (VendorId > 0) {
      postApi(`Purchase/purchase-transaction-list`, {
        Id: parseInt(VendorId),
        displayStart: 1,
        pageSize: 100000,
        searchText: '',
        sortColumn: "",
        sortOrder: "asc",
        fromDate: null,
        toDate: null,
      }).then(({ data, status }) => {
        if (status === 200) {
          toggleTransaction()
          setTransactionData(data?.TransactionList)
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
    }
  }

  // Category table header & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "Name",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{ color: "blue", cursor: "pointer" }} onClick={() => handleViewTransaction(row.original.Id)}>
                {row.original.Name}
              </div>
            </>
          )
        },
      },
      {
        Header: "Contact#",
        accessor: "ContactNo",
        width: "9%"
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        width: "8%",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditVendor(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  id={`deletetooltip${row.original.Id}`}
                  className="fs-6 fas fa-trash-alt btn-delete"
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  const transactioncolumns = useMemo(
    () => [
      {
        Header: "Created On",
        accessor: "CreatedOn",
        width: "10%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original?.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Paid Amt.",
        accessor: "PaidAmount",
        width: "7%",
        Cell: ({ row }) => {
          return (
            <div style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              textAlign: "end"
            }}>
              <i className="mdi mdi-currency-inr"></i>
              {new Intl.NumberFormat('en-IN', {
                currency: 'INR',
                minimumFractionDigits: 2,
              }).format(row?.original?.PaidAmount || 0)}
            </div>
          )
        },
      },
      {
        Header: "Payment Mode",
        accessor: "PaymentMode",
        width: "8%",
        Cell: ({ row }) => {
          return (
            <>
              <div>
                {row.original.PaymentMode == 1 ? "Cash" : "Bank"}
              </div>
            </>
          )
        },
      },
      {
        Header: "Created By",
        accessor: "CreatedByName",
        width: "10%"
      },
      {
        Header: "Remark",
        accessor: "Remark",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{ textWrap: "wrap" }}>
                {row.original.Remark == null || row.original.Remark == '' ? "N/A" : row.original.Remark}
              </div>
            </>
          )
        },
      },
    ],
    [transactionData]
  )

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Name", "ContactNo"];
    const mainTitle = "Vendors";
    const widthObj = [{
      Key: "A",
      Value: 30,
    },
    {
      Key: "B",
      Value: 18,
    },
    ]
    const extention = "Vendors.xlsx"
    let excelSheetData = []
    for (let index = 0; index < tableData.length; index++) {
      let dataObj = {
        Name: tableData[index].Name,
        ContactNo: tableData[index].ContactNo,
      }
      excelSheetData.push(dataObj)
    }
    var fields = Object.keys(excelSheetData[0]);
    var sheetData = excelSheetData.map(function (row) {
      return fields.map(function (fieldName) {
        return row[fieldName];
      });
    });
    setIsLoading(false)
    sheetData.unshift(header);
    exportDataExcel(sheetData, mainTitle, widthObj, extention)
  }

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <VendorsTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isCategoryList={true}
              handleVendorClick={handleVendorClick}
              customPageSize={10}
              className="custom-header-css"
              isLoading={isLoading}
              TotalRecords={totalRecords}
              writeDataToExcel={writeDataToExcel}
            />

            <Modal
              isOpen={transactionModal}
              toggle={toggleTransaction}
              centered={true}
              size="default"
              style={{ width: !isMobile ? "" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggleTransaction} tag="h5">
                  Transactions
                </ModalHeader>
                <ModalBody>
                  <TransactionTable
                    columns={transactioncolumns}
                    data={transactionData}
                  />
                </ModalBody>
              </div>
            </Modal>

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Vendor" : "Create Vendor"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Name
                        </Label>
                        <Input
                          name="Name"
                          placeholder="Vendor Name"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.Name || ""}
                          invalid={
                            validation.touched.Name && validation.errors.Name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Name && validation.errors.Name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Name}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <Row>
                      <FormGroup className="mb-2">
                        <Label
                          htmlFor="validationCustom03"
                          className="required"
                        >
                          Contact No.
                        </Label>
                        <Input
                          name="ContactNo"
                          placeholder="Contact no."
                          type="text"
                          maxLength={10}
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          onKeyPress={handleKeyPress}
                          value={validation.values.ContactNo}
                          invalid={
                            validation.touched.ContactNo && validation.errors.ContactNo
                              ? true
                              : false
                          }
                        />
                        {validation.touched.ContactNo && validation.errors.ContactNo ? (
                          <FormFeedback type="invalid">
                            {validation.errors.ContactNo}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm"
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div >
  )
}
Vendors.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Vendors